import type { GetEstimatesQueryParams } from '../../../types/estimate.js'

export const estimateKeys = {
  all: ['estimates'] as const,
  clientPassengers: (clientId: string) => ['client-passengers', clientId] as const,
  clientSearch: (query: string) => ['client-search', query] as const,
  detail: (estimateId: string) => ['estimate-detail', estimateId] as const,
  formData: (id: string) => ['estimate-form-data', id] as const,
  infoMinimal: (id: string) => ['estimate-info-minimal', id] as const,
  list: (params: GetEstimatesQueryParams) => ['estimates', 'list', params] as const,
}
